// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-bell-curve';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576.576v16.848h16.848' />
    <path d='M10.584 13.032c.288.504.648.864 1.08 1.224l.504.36m-9.36 0 .504-.36c1.008-.72 1.584-1.8 1.656-3.024l.288-5.256c.072-1.152 1.08-2.016 2.232-2.016h.072' />
    <path d='m6.84 14.616.504-.36c1.008-.72 1.584-1.8 1.656-3.024l.36-5.256c.072-1.152 1.08-2.016 2.232-2.016s2.16.864 2.232 2.016l.288 5.256c.072 1.224.72 2.304 1.656 3.024l.504.36' />
  </g>
);

export const viewBox = '0 0 18 18';
